import { initGlobalApi } from './global-api/index';
import WebViewer from './instance/index';

initGlobalApi(WebViewer);

WebViewer.version = BUILD_VERSION; // eslint-disable-line no-undef
WebViewer.buildDate = BUILD_DATE; // eslint-disable-line no-undef

export default WebViewer;



// WEBPACK FOOTER //
// ./src/viewer/core/index.js